import React from 'react'

export default function InputRadio({ checked, ...others }: props) {
  return (
    <input {...others} type="radio" checked={checked} className="uk-radio" />
  )
}



// WEBPACK FOOTER //
// ./src/components/InputRadio/InputRadio.js